module.exports = __webpack_public_path__ + "static/img/merchant_case_4.575bf64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_case_4.png
// module id = wFpy
// module chunks = 8